"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var _classNames, _classNames2;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onOpen = props.onOpen,
      label = props.label,
      placeholder = props.placeholder,
      disabled = props.disabled,
      clear = props.clear,
      type = props.type,
      onClear = props.onClear,
      startDate = props.startDate,
      endDate = props.endDate,
      date = props.date,
      _props$classNameMap = props.classNameMap,
      classNameMap = _props$classNameMap === void 0 ? {} : _props$classNameMap;
  var haveValue = type === 'single' ? date : startDate || endDate;
  var canDelete = haveValue && clear && !disabled;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, classNameMap.DatePickerValueholderClassName, true), _defineProperty(_classNames, classNameMap.DatePickerValueholderDeleteClassName, canDelete), _classNames))
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, classNameMap.DatePickerValueholderChooseDivClassName, true), _defineProperty(_classNames2, classNameMap.DatePickerValueholderPlaceholderClassName, label === placeholder), _defineProperty(_classNames2, classNameMap.DatePickerValueholderDisabledClassName, disabled), _classNames2)),
    onClick: onOpen
  }, _react["default"].createElement("span", null, label)), _react["default"].createElement("div", {
    className: classNameMap.DatePickerValueholderIconDivClassName,
    onClick: onOpen
  }, _react["default"].createElement("i", {
    className: "svg svg-date"
  }), canDelete ? _react["default"].createElement("i", {
    className: "svg svg-del svg-del-16",
    onClick: function onClick(event) {
      onClear(event);
      event.stopPropagation();
    }
  }) : null));
};

exports["default"] = _default;